import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-carton-upload',
  templateUrl: './carton-upload.component.html',
  styleUrls: ['./carton-upload.component.scss']
})
export class CartonUploadComponent implements OnInit {

  uploadHidden = false;
  excel_data: any;
  approvedReject: any = [];
  offerId = "";
  voucherData: any;
  uploadId: any = [];
  caplimt: any;
  apiData: any;
  tableData = {
    headers: [],
    rows: [],
    keys: []
  }
  specialFlag = 0
  cartonId: any = "";
  SpecialOcceranceExcelData: any = []
  speciadatelData: any = []
  isExcelUpload : boolean = false;
  brandList = [];
  cartonLocalFlags : any = {}
  id:any ;
  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private apiconfig: ApiConfiguration,
    private exportExcelService: ExportExcelService,
    private activatedRoute: ActivatedRoute,
    private xlsx: XlsxService,
    private toast: ToastClientService,
    private router: Router,


  ) {
    this.uploadId = this.activatedRoute.snapshot.paramMap.get("id")
    this.caplimt = this.activatedRoute.snapshot.paramMap.get("caplimt")
    this.caplimt = this.activatedRoute.snapshot.paramMap.get("caplimt")
    console.log("caplimit",this.caplimt)
    this.cartonId = this.activatedRoute.snapshot.paramMap.get("cartonid")

  }

  ngOnInit() {
    this.id =
    this.cartonLocalFlags = JSON.parse(localStorage.getItem('cartonFlgs'))
    this.getBrand();

  }
getBrand(){
  this.apiService.get(this.apiconfig.cartonBrand).subscribe((res : any)=>{
    console.log(res)
    this.brandList = res.data;
  })
}



  openUploadmodel(modal) {
    this.modalService.open(modal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  uploadXlsx(eve, modal) {
    // debugger
    this.xlsx.uploadXlsx(eve).then((res: any) => {
      console.log(res)
      if (this.uploadId == 2) {
        this.whitelistUpload(res.data)
      }
      else if (this.uploadId == 3) {
        this.PointConfigurationUpload(res.data);
      }
      else if (this.uploadId == 4) {
        this.targetListUpload(res.data)
      }
      else if (this.uploadId == 5) {
        this.specialOccranceUpload(res.data, modal)
        this.SpecialOcceranceExcelData = res.data;
      }
    })
  }




  whitelistUpload(res) {
    let payload = {
      carton_campaign_id: this.cartonId,
      excel_data: res
    }
    this.tableData.headers = [];
    this.tableData.rows = [];
    this.tableData.keys = [];
    this.apiService.post(this.apiconfig.cartonWhiteListUser, payload).subscribe((res: any) => {
      console.log(res)
      try{
        localStorage.setItem("whiteListFlag", "true");
        if(res.body.data.total_assigned_users !=0){
          this.toast.Success("Excel uploaded successfully.")
          console.log("qwertyuiopasdfghjkls",res.body.data)
          this.apiData = res.body.data;
          this.uploadHidden = true;
          localStorage.setItem("pointConfigrationFlag", "true");
          this.cartonLocalFlags = JSON.parse(localStorage.getItem('cartonFlgs'))
          this.cartonLocalFlags = { ...this.cartonLocalFlags, whiteListFlag : true}
          this.cartonLocalFlags = { ...this.cartonLocalFlags, type1whiteList : true}
          localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))
          this.isExcelUpload = true
        }else{
          debugger
          if(this.cartonLocalFlags.type1whiteList){
            this.toast.Error(res.body.data.message)
            localStorage.setItem("pointConfigrationFlag", "false");
            this.cartonLocalFlags = JSON.parse(localStorage.getItem('cartonFlgs'))
            this.cartonLocalFlags = { ...this.cartonLocalFlags, whiteListFlag : true}
            this.cartonLocalFlags = { ...this.cartonLocalFlags, type1whiteList : true}
            localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))
            console.log("qwertyuiopasdfghjkls",res.body.data,JSON.parse(localStorage.getItem('cartonFlgs')))
          }else{
            this.toast.Error(res.body.data.message)
            localStorage.setItem("pointConfigrationFlag", "false");
            this.cartonLocalFlags = JSON.parse(localStorage.getItem('cartonFlgs'))
            this.cartonLocalFlags = { ...this.cartonLocalFlags, whiteListFlag : false}
            this.cartonLocalFlags = { ...this.cartonLocalFlags, type1whiteList : false}
            localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))
            console.log("qwertyuiopasdfghjkls",res.body.data,JSON.parse(localStorage.getItem('cartonFlgs')))
          }

        }
        localStorage.setItem("targetFlag", "false");
        localStorage.setItem("specialOccasionFlag", "false");
        this.uploadHidden = true;
        this.apiData = res.body.data;
        this.tableData.headers = ["Outlet Code", "Reason"]
        this.tableData.rows = res.body.data.failed_users;
        for (const [key, value] of Object.entries(this.tableData.rows[0])) {
          console.log(key, value);
          this.tableData.keys.push(key)
        }
        console.log(this.tableData)
        }
        catch{

        }
    }, err => {
      console.log(err)
    })
  }

  PointConfigurationUpload(res) {
    let payload = {
      carton_campaign_id: this.cartonId,
      excel_data: res
    }
    this.tableData.headers = [];
    this.tableData.rows = [];
    this.tableData.keys = [];
    this.apiService.post(this.apiconfig.pointConfigurationUpload, payload).subscribe((res: any) => {
      console.log(res)
      this.toast.Success("success")
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "true");
      if(res.body.data.total_assigned_users !=0){
        localStorage.setItem("targetFlag", "true");
        this.isExcelUpload = true
        localStorage.setItem("targetFlag", "true");
        this.cartonLocalFlags = { ...this.cartonLocalFlags, pointConfigrationFlag : true}
        localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))

      }else{
        if(this.cartonLocalFlags.pointConfigrationFlag){
          localStorage.setItem("targetFlag", "false");
          this.cartonLocalFlags = { ...this.cartonLocalFlags, pointConfigrationFlag : true}
          localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))
        }else{
          localStorage.setItem("targetFlag", "false");
          this.cartonLocalFlags = { ...this.cartonLocalFlags, pointConfigrationFlag : false}
          localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))
        }
      }
      localStorage.setItem("specialOccasionFlag", "false");
      this.uploadHidden = true;
      this.apiData = res.body.data;
      this.tableData.headers = ["Outlet Code", "Reason"]
      this.tableData.rows = res.body.data.failed_users;
      for (const [key, value] of Object.entries(this.tableData.rows[0])) {
        console.log(key, value);
        this.tableData.keys.push(key)
      }
      console.log(this.tableData)
    }, err => {
      console.log(err)
    })
  }

  specialOccranceUpload(res, modal) {
    let payload = {
      carton_campaign_id: this.cartonId,
      excel_data: res,
      flag: this.specialFlag
    }
    this.tableData.headers = [];
    this.tableData.rows = [];
    this.tableData.keys = [];

    this.apiService.post(this.apiconfig.specialOcceranceUpload, payload).subscribe((res: any) => {
      console.log(res)
      this.toast.Success("success")
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "true");
      localStorage.setItem("targetFlag", "true");
      localStorage.setItem("specialOccasionFlag", "true");
      debugger
      if (res.body.data.popup_flag == false) {
        this.uploadHidden = true;
        this.tableData.headers = ["Outlet Code", "Reason"]
        this.apiData = res.body.data;
        this.tableData.rows = res.body.data.failed_users;
        for (const [key, value] of Object.entries(this.tableData.rows[0])) {
          console.log(key, value);
          this.tableData.keys.push(key)
        }
        console.log(this.tableData)
      } else {
        this.speciadatelData = res.body.data.hold_users;
        this.openUploadmodel(modal)

      }
    }, err => {
      console.log(err)
    })
  }

  targetListUpload(res) {
    let payload = {
      carton_campaign_id: this.cartonId,
      excel_data: res
    }
    this.tableData.headers = [];
    this.tableData.rows = [];
    this.tableData.keys = [];

    this.apiService.post(this.apiconfig.cartonUploadTarget, payload).subscribe((res: any) => {
      console.log(res)
      this.toast.Success("success")
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "true");
      localStorage.setItem("targetFlag", "true");
      if(res.body.data.total_assigned_users !=0){
        localStorage.setItem("specialOccasionFlag", "true");
        this.cartonLocalFlags = { ...this.cartonLocalFlags, targetFlag : true}
        localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))
        this.isExcelUpload = true
      }else{
        if(this.cartonLocalFlags.targetFlag){
          localStorage.setItem("specialOccasionFlag", "false");
          this.cartonLocalFlags = { ...this.cartonLocalFlags, targetFlag : true}
          localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))
        }else{
          localStorage.setItem("specialOccasionFlag", "false");
          this.cartonLocalFlags = { ...this.cartonLocalFlags, targetFlag : false}
          localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))
        }

      }
      this.uploadHidden = true;
      this.tableData.headers = ["Outlet Code", "Reason"]
      this.apiData = res.body.data;
      this.tableData.rows = res.body.data.failed_users;
      for (const [key, value] of Object.entries(this.tableData.rows[0])) {
        console.log(key, value);
        this.tableData.keys.push(key)
      }
      console.log(this.tableData)
    }, err => {
      console.log(err)
    })
  }

  downloadExcel() {

    // upload id 2 for whitelist user
    // upload id 3 for point calculation
    // upload id 4 for target
    // upload id 5 for special occrence




    if (this.uploadId == 2) {
      if (this.caplimt == 0) {
        let sheetName = "Individual";
        let filename = "Carton_Whitelist_Users";
        let excelData = [{ Outlet_Code: "12345" }]
        let excelArray = [
          {
            header: "Outlet Code",
            key: "Outlet_Code"
          },
          // {
          //   header: "Mobile Number",
          //   key: "mobile_number"
          // }
        ]
        this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
      } else {
        let sheetName = "Overall";
        let filename = "Carton_Whitelist_Users";
        let excelData = [{ Outlet_Code: "12345", Min_Limit: '80', Max_Limit: "100" }]
        let excelArray = [
          {
            header: "Outlet Code",
            key: "Outlet_Code"
          },
          {
            header: "Min Limit",
            key: "Min_Limit"
          },
          {
            header: "Max Limit",
            key: "Max_Limit"
          },
          // {
          //   header: "Mobile Number",
          //   key: "mobile_number"
          // }


        ]
        this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);




        // let header1 = ["Outlet Code","Min Limit","Max Limit"]
        // let sheetName1 = "Overall";
        // let filename = "Carton_Whitelist_Users";
        // this.exportExcelService.commonOneSheetPrintHeaders(header1 , sheetName1 ,filename)
      }
    } else if (this.uploadId == 3) {
      let sheetName = "Points Structure";
      let filename = "Carton_Point_Structure";
      let excelData = [
        {
          Outlet_Code: "12345",
          Carton_Brand: '',
          Points: "10",
          Min: '90',
          Max: '100'
        }
      ]
      let excelArray = [
        {
          header: "Outlet Code",
          key: "Outlet_Code"
        },
        {
          header: "Carton Brand",
          key: "Carton_Brand"
        },
        {
          header: "Points",
          key: "Points"
        },
        {
          header: "Min %",
          key: "Min"
        },
        {
          header: "Max %",
          key: "Max"
        },
        // {
        //   header: "Mobile Number",
        //   key: "mobile_number"
        // }

      ]
      let sheetName2 = "brands";
      let productHeader = ["Brand"]
      // this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
      this.exportExcelService.DownloadCartonSetpsExcel(filename, sheetName, excelData, excelArray ,sheetName2, productHeader,this.brandList);




      // let header1 = ["Outlet Code","Carton Brand","Points","Min","Max"]
      // let sheetName1 = "Points Structure";
      // let filename = "Carton_Point_Structure";
      // this.exportExcelService.commonOneSheetPrintHeaders(header1  ,sheetName1 , filename)
    }
    else if (this.uploadId == 4) {

      let sheetName = "Sheet1";
      let filename = "Carton_Target";
      let excelData = [
        {
          Outlet_Code: "12345",
          Carton_Brand: '',
          Target_Qty: "80",
        }
      ]
      let excelArray = [
        {
          header: "Outlet Code",
          key: "Outlet_Code"
        },
        {
          header: "Carton Brand",
          key: "Carton_Brand"
        },
        {
          header: "Target Qty",
          key: "Target_Qty"
        },
      ]
      let sheetName2 = "brands";


       let productHeader = ["Brand"]
    //  let product = [
    //    {
    //     product_type:"Per",
    //    },
    //    {
    //     product_type:"Flat",
    //   },
    // ]
      this.exportExcelService.DownloadCartonSetpsExcel(filename, sheetName, excelData, excelArray ,sheetName2, productHeader,this.brandList);



      // let header1 = ["Outlet Code","Carton Brand","Target Qty"]
      // let sheetName1 = "Sheet1";
      // let filename = "Carton Target";
      // this.exportExcelService.commonOneSheetPrintHeaders(header1  , sheetName1 , filename)
    }
    else if (this.uploadId == 5) {
      let filename = "Carton_Special";
      let excelHeader = ["Outlet Code",
      "Carton Brand",
      "Start Date",
      "End Date",
      "Points",
      "Scan Limit",
       "Points Type",
      //  "Mobile Number"
      ]
       let excelstatic = ["123456",
      "",
      "YYYY-MM-DD",
      "YYYY-MM-DD",
      "10",
      "80",
       "Flat"]
       let sheetName1 = "Spl Occasion";
       let sheetName2 = "Products";


       let productHeader = ["Product Type"]
     let product = [
       {
        product_type:"Per",
       },
       {
        product_type:"Flat",
      },
     ]
      this.exportExcelService.cartanSpecialOcceranceExcel(product , excelHeader , productHeader ,filename,sheetName1, sheetName2 , excelstatic , this.brandList);


    }
  }

  RejectedOutletExcel() {
    // common function to print rejected recoeds
    this.xlsx.export(this.tableData.rows, "rejected_list")
  }
  ngOnDestroy() {
    if (this.uploadId == 2 && this.isExcelUpload == false) {
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "false");
      localStorage.setItem("targetFlag", "false");
      localStorage.setItem("specialOccasionFlag", "false");
    }
    else if (this.uploadId == 3 && this.isExcelUpload == false) {
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "true");
      localStorage.setItem("targetFlag", "false");
      localStorage.setItem("specialOccasionFlag", "false");
    }
    else if (this.uploadId == 4 && this.isExcelUpload == false) {
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "true");
      localStorage.setItem("targetFlag", "true");
      localStorage.setItem("specialOccasionFlag", "false");
    }
    else if (this.uploadId == 5 && this.isExcelUpload == false) {
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "true");
      localStorage.setItem("targetFlag", "true");
      localStorage.setItem("specialOccasionFlag", "true");
    }
  }

  specialOccerancelApprove(id) {
    this.modalService.dismissAll()
    this.specialFlag = id
    this.specialOccranceUpload(this.SpecialOcceranceExcelData, null)
  }


}

/**
 * @author Govadhan
 * @description In carton insert special occession when we upload excel for the first time, we send flag 0
 * In excel if difference between starte date and end date is 10 days,s then we show the list. If it is approved then => 1
 *  If reject => 2
 */

